import referralTypes from "./referralTypes";
import { PENDING, SUCCESS, ERROR } from "../../globalStatuses/globalStatuses";

const initialState = {
    status: '',
    analytics: null,
}

const referralReducer = (state = initialState, action) => {
    switch (action.type) {
        case referralTypes.GET_REFERRAL_ANALYTICS_PENDING:
            return { ...state, status: PENDING }
        case referralTypes.GET_REFERRAL_ANALYTICS_SUCCESS:
            return { ...state, status: SUCCESS, analytics: action.payload }
        case referralTypes.GET_REFERRAL_ANALYTICS_ERROR:
            return { ...state, status: ERROR }
        default:
            return state
    }
}

export default referralReducer;
